module.exports = __webpack_public_path__ + "img/adefault.b5e6fa2d.png";